import React from "react";
import { Link } from "react-router-dom";

const AuthFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative z-10 py-6 sm:py-8 border-t border-gray-700/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Copyright */}
          <p className="text-gray-400 text-xs sm:text-sm text-center sm:text-left">
            © {currentYear} Viszapp. All rights reserved.
          </p>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-xs sm:text-sm">
            <Link
              to="/terms"
              className="text-gray-400 hover:text-teal-400 transition-colors duration-300"
            >
              Terms & Conditions
            </Link>
            <Link
              to="/privacy"
              className="text-gray-400 hover:text-teal-400 transition-colors duration-300"
            >
              Privacy Policy
            </Link>
            <Link
              to="/service-policies"
              className="text-gray-400 hover:text-teal-400 transition-colors duration-300"
            >
              Service Policies
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AuthFooter;